import { AccountInvitePage } from '@online-webinar/account';
import { RouterType } from '@online-webinar/router';

export const updateRoute = (router: RouterType) => {
    router.routesById['/r/$accountInviteId'].update({
        staticData: { title: { page: 'AccountInvite.PageHeading' } },
        component: AccountInvitePage
    });
};
